var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderVeicolo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 89,
    viewBox: "0 0 48 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4308_19982",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 89
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 89,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4308_19982)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "opacity-to-fill",
    opacity: 0.1,
    x: -155,
    y: -134,
    width: 358,
    height: 358,
    rx: 8,
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9771 -86.999L51.978 -87C51.9846 -87 51.9911 -87 51.9976 -87C59.812 -87 64.5023 -87.0124 68.8716 -85.7461C73.2766 -84.4694 77.2672 -81.9252 83.856 -77.1553C84.5268 -76.6694 84.6767 -75.7315 84.1909 -75.0605C83.7051 -74.3898 82.7671 -74.2399 82.0962 -74.7256C75.4807 -79.5149 71.8765 -81.7511 68.0357 -82.8643C66.3093 -83.3645 64.5173 -83.6442 62.354 -83.8008C65.7721 -81.689 69.2033 -78.1932 71.189 -72.4473C75.895 -58.8295 81.476 -38.7355 81.4761 -16.1943C81.4761 -5.01414 80.7962 27.6691 79.5317 61.1348C78.2689 94.5585 76.4185 128.92 74.0601 143.372C71.7209 157.706 69.5878 165.49 67.3608 169.808C66.2288 172.002 65.0222 173.404 63.6616 174.296C62.3073 175.184 60.9363 175.472 59.7271 175.678C58.4363 175.897 52.9929 176.247 45.6401 176.531C39.4631 176.77 31.8413 176.963 23.9761 176.993V173.993C23.9995 173.993 24.023 173.993 24.0464 173.993C31.8413 173.962 39.396 173.77 45.5239 173.533C52.971 173.245 58.1745 172.898 59.2241 172.72C60.3546 172.527 61.2071 172.317 62.0171 171.786C62.8209 171.259 63.7211 170.32 64.6948 168.433C66.6798 164.584 68.7583 157.233 71.0991 142.889C73.4208 128.662 75.2683 94.5139 76.5337 61.0215C77.7976 27.5711 78.4761 -5.06916 78.4761 -16.1943C78.476 -38.2636 73.008 -58.0005 68.354 -71.4678C66.1751 -77.7727 62.0718 -80.8762 58.5171 -82.4336C56.7253 -83.2186 55.0658 -83.6114 53.8579 -83.8076C53.2554 -83.9055 52.7693 -83.9539 52.4409 -83.9775C52.2772 -83.9893 52.153 -83.9944 52.0737 -83.9971C52.0341 -83.9984 52.0052 -83.9997 51.9888 -84H23.9761V-87C30.3649 -87 36.2935 -86.9996 51.9761 -87L51.9771 -86.999Z",
    fill: "#444340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.21337 -86.999L-4.21434 -87H-4.23485C-12.1226 -87 -16.852 -87.0121 -21.2573 -85.7471C-25.6987 -84.4715 -29.7243 -81.9294 -36.3745 -77.1592C-37.047 -76.6763 -37.2015 -75.7393 -36.7192 -75.0664C-36.2364 -74.3934 -35.2986 -74.2391 -34.6255 -74.7217C-27.9495 -79.5104 -24.3096 -81.7489 -20.4292 -82.8633C-18.6821 -83.365 -16.8678 -83.6442 -14.6782 -83.8008C-18.1237 -81.6904 -21.5855 -78.1964 -23.5893 -72.4512C-28.339 -58.8333 -33.9721 -38.7381 -33.9722 -16.1953C-33.9722 -5.01506 -33.2864 27.6677 -32.0102 61.1328C-30.7357 94.5557 -28.8672 128.918 -26.4868 143.371C-24.1261 157.704 -21.9731 165.49 -19.7251 169.809C-18.5821 172.004 -17.3643 173.405 -15.9936 174.295C-14.6304 175.18 -13.2509 175.468 -12.0317 175.674C-10.7316 175.893 -5.23888 176.243 2.18312 176.527C8.41706 176.766 16.109 176.959 24.0464 176.989V173.993V173.989C16.1538 173.959 8.50086 173.767 2.29737 173.529C-5.21735 173.241 -10.4713 172.895 -11.5327 172.716C-12.6747 172.523 -13.5391 172.312 -14.3599 171.779C-15.1735 171.251 -16.0818 170.31 -17.064 168.424C-19.0667 164.577 -21.1644 157.226 -23.5268 142.883C-25.8698 128.657 -27.735 94.5106 -29.0122 61.0186C-30.2877 27.5688 -30.9722 -5.07059 -30.9722 -16.1953C-30.9721 -38.262 -25.4543 -57.9972 -20.7573 -71.4639C-18.5592 -77.7659 -14.4176 -80.8719 -10.8247 -82.4316C-9.01458 -83.2174 -7.33746 -83.6111 -6.11669 -83.8076C-5.50808 -83.9056 -5.01613 -83.9539 -4.68407 -83.9775C-4.51872 -83.9893 -4.39235 -83.9944 -4.312 -83.9971C-4.27271 -83.9984 -4.24387 -83.9997 -4.22704 -84H24.0464V-87C17.5983 -87 11.6142 -86.9986 -4.21337 -86.999Z",
    fill: "#444340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.6904 -10.0723H59.9307C62.5046 -10.072 64.5543 -7.91648 64.4248 -5.3457L59.4131 94.1807C59.2925 96.5748 57.3161 98.4549 54.9189 98.4551H-6.67871C-9.07595 98.455 -11.0523 96.5749 -11.1729 94.1807L-16.1846 -5.3457C-16.314 -7.91656 -14.2645 -10.0722 -11.6904 -10.0723Z",
    stroke: "#444340",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "border-to-stroke",
    d: "M-98 88H132",
    stroke: "",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "border-to-stroke",
    x1: 47,
    y1: -116,
    x2: 47,
    y2: 204,
    stroke: "",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "border-to-stroke",
    x1: -98,
    y1: 1,
    x2: 132,
    y2: 1,
    stroke: "",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "border-to-stroke",
    x1: 1,
    y1: 205,
    x2: 1,
    y2: -115,
    stroke: "",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.427734,
    width: 44,
    height: 88,
    fill: "url(#pattern0_4308_19982)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4308_19982",
    patternUnits: "userSpaceOnUse",
    patternTransform: "matrix(14.5 0 0 14.5 0.585693 -0.986327)",
    preserveAspectRatio: "none",
    viewBox: "-1.41431 -1.41406 14.5 14.5",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern0_4308_19982_inner",
    transform: "translate(-29 -29)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern0_4308_19982_inner",
    transform: "translate(-14.5 -29)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern0_4308_19982_inner",
    transform: "translate(0 -29)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern0_4308_19982_inner",
    transform: "translate(-29 -14.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern0_4308_19982_inner",
    transform: "translate(-14.5 -14.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern0_4308_19982_inner",
    transform: "translate(0 -14.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern0_4308_19982_inner",
    transform: "translate(-29 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern0_4308_19982_inner",
    transform: "translate(-14.5 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pattern0_4308_19982_inner"
  }, /*#__PURE__*/React.createElement("line", {
    id: "border-to-stroke",
    x1: -0.707107,
    y1: 28.2929,
    x2: 28.2929,
    y2: -0.707107,
    stroke: "",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderVeicolo);
export default __webpack_public_path__ + "static/media/placeholder_veicolo.e8810b78ce7ce4e4442b7504c75e6f46.svg";
export { ForwardRef as ReactComponent };